import React from 'react';
import { type User as FirebaseUser } from 'firebase/auth';
import type { FirebaseApp } from 'firebase/app';
import type { UserMetadata } from '@/hooks/auth';

export interface AuthContext {
  login: () => Promise<void>;
  logout: () => Promise<void>;
  firebaseUser: FirebaseUser | null | undefined;
  ready: boolean;
  authorized: boolean | undefined;
  authorizationErrorMessage: string | null;
  idToken: string | null;
  userMetadata: UserMetadata | null;
  /** The signed-in sysadmin while beta act-as mode is active. */
  actorMetadata: UserMetadata | null;
  actingAsUserId: string | null;
}

export type FirebaseContext = {
  app?: FirebaseApp;
  firebaseConfig?: Record<string, unknown>;
};

export const AuthContext = React.createContext<AuthContext>({
  firebaseUser: undefined,
  login: async () => {},
  logout: async () => {},
  ready: false,
  authorized: false,
  authorizationErrorMessage: null,
  idToken: null,
  userMetadata: null,
  actorMetadata: null,
  actingAsUserId: null,
});

export const FirebaseContext = React.createContext<FirebaseContext>({});
